
<link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons">
<!-- <div>
    <h4 >Login</h4>
    <div >
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="form-group">
                <label for="username">Email</label>
                <input type="text" formControlName="username" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.username.errors }" />
                <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                    <div *ngIf="f.username.errors.required">Email is required</div>
                </div>
            </div>
            <div class="form-group">
                <label for="password">Password</label>
                <input type="password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                    <div *ngIf="f.password.errors.required">Password is required</div>
                </div>
            </div>
            <div class="form-group">
                <button [disabled]="loading" class="btn btn-primary">
                    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    Login
                </button>
                <a routerLink="../signup" class="btn btn-link">Register</a>
            </div>
        </form>
    </div>
</div> -->
<div class="login_block">
    <div class="container">
        
        <div class="login_form">
            <div class="page-logo center">
                <img src="./../../assets/images/f_logo.png" width="150" class="responsive-img" alt="AutoConfig.com">
            </div>
            <div class="user-icon center">
                <img src="./../../assets/images/user.svg" width="100" class="responsive-img" alt="user">
            </div>
            <div class="title center">Sign In</div>
            <form [formGroup]="form" (ngSubmit)="onSubmit()"  class="formInput">
                <div class="row">
                    <div class="input-field _input-field col s12">
                        <i class = "material-icons prefix" >person</i>
                        <input type="text" formControlName="username" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.username.errors }" placeholder="Email address" (focus) = 'onFocus($event)' (blur)= 'onBlur($event)' />
                        <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                            <div *ngIf="f.username.errors.required">Email is required</div>
                        </div>
                    </div>   
                    <div class="input-field _input-field col s12">
                        <i class = "material-icons prefix">lock</i>
                        <input type="password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" placeholder="Password" (focus) = 'onFocus($event)' (blur)= 'onBlur($event)' />
                <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                    <div *ngIf="f.password.errors.required">Password is required</div>
                </div> 
                    </div> 
                </div>
                <div class="row mb-0"> 
                    <div class="login-btn col s12">
                        <button [disabled]="loading" class="btn btn-orange login">
                            <!-- <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span> -->
                            Login
                        </button>
                        
                    </div> 
                </div>
                <div class="center-align register-link">
                    New customer? <a routerLink="../signup" class="link">Signup here</a>
                </div>
            </form>
         </div>
    </div>
</div>
